import axios from 'axios'

export const getCarsCalculusData = async (item: any, url: string) => {
  try {
    const make_model = item?.vehicleModel?.replaceAll(' ', '_')?.toLowerCase()
    const params = `?make_model=${make_model}&motor_type=${item.vehiclefuel}&km=${item.distanceKlm}`
    const carUrl = `${url}${params}`
    const { data } = await axios.get(carUrl)
    return data
  } catch (e) {
    let errors = ''
    for (const property in e?.response?.data?.errors) {
      errors += `${property}: ${e?.response?.data?.errors[property]}.`
    }
    const error = { error: errors, isError: true }
    return error
  }
}
